"use client";

// packages/eden-fade/src/components/Scrollable.jsx
import { useContext, forwardRef } from "react";
import styled from "styled-components";
import { OverflowContext } from '../utils/context.js';
import { mergeRefs } from "@churchofjesuschrist/eden-utilities";
import { jsx } from "react/jsx-runtime";
var ScrollContainer = styled.div`
  position: relative;
  overflow: auto;
  z-index: 1;
`;
var ScrollableComponent = ({ children, renderAs, ...props }, forwardedRef) => {
  const overflowRef = useContext(OverflowContext);
  return /* @__PURE__ */ jsx(
    ScrollContainer,
    {
      as: renderAs,
      ...props,
      ref: mergeRefs(overflowRef, forwardedRef),
      children
    }
  );
};
var Scrollable = forwardRef(ScrollableComponent);
Scrollable.displayName = "Scrollable";
var Scrollable_default = Scrollable;
export {
  Scrollable_default as default
};
